import React from 'react';

import { Route, Routes } from 'react-router-dom';

import CompaniesEdit from './pages/companies/CompaniesEdit';
import CompaniesIndex from './pages/companies/CompaniesIndex';
import CompaniesNew from './pages/companies/CompaniesNew';
import CustomersEdit from './pages/customers/CustomersEdit';
import CustomersIndex from './pages/customers/CustomersIndex';
import CustomersNew from './pages/customers/CustomersNew';
import HomePage from './pages/home/HomePage';
import InvoiceStatusesEdit from './pages/invoice-statuses/InvoiceStatusesEdit';
import InvoiceStatusesIndex from './pages/invoice-statuses/InvoiceStatusesIndex';
import InvoiceStatusesNew from './pages/invoice-statuses/InvoiceStatusesNew';
import InvoicesEdit from './pages/invoices/InvoicesEdit';
import InvoicesIndex from './pages/invoices/InvoicesIndex';
import InvoicesNew from './pages/invoices/InvoicesNew';
import LoginPage from './pages/login/LoginPage';
import NoMatch from './components/NoMatch';
import ProductsEdit from './pages/products/ProductsEdit';
import ProductsIndex from './pages/products/ProductsIndex';
import ProductsNew from './pages/products/ProductsNew';
import Profile from './pages/profile/Profile';
import RequireAuth from './components/RequireAuth';
import ServicesEdit from './pages/services/ServicesEdit';
import ServicesIndex from './pages/services/ServicesIndex';
import ServicesNew from './pages/services/ServicesNew';
import SignIndex from './pages/sign/SignIndex';
import TransactionNaturesEdit from './pages/transaction-natures/TransactionNaturesEdit';
import TransactionNaturesIndex from './pages/transaction-natures/TransactionNaturesIndex';
import TransactionNaturesNew from './pages/transaction-natures/TransactionNaturesNew';
import UsersEdit from './pages/users/UsersEdit';
import UsersIndex from './pages/users/UsersIndex';
import UsersNew from './pages/users/UsersNew';

import { useAuth } from './contexts/auth';
import EstimatesIndex from './pages/estimates/EstimatesIndex';
import EstimatesNew from './pages/estimates/EstimatesNew';
import EstimatesEdit from './pages/estimates/EstimatesEdit';
import RemindersIndex from './pages/reminders/RemindersIndex';
import RemindersEdit from './pages/reminders/RemindersEdit';
import RemindersNew from './pages/reminders/RemindersNew';
import ReportsIndex from './pages/reports/ReportsIndex';
import ReportsShow from './pages/reports/ReportsShow';
import TagsIndex from './pages/tags/TagsIndex';
import TagsEdit from './pages/tags/TagsEdit';
import TagsNew from './pages/tags/TagsNew';
import PayrollsIndex from './pages/payrolls/PayrollsIndex';
import PayrollsShow from './pages/payrolls/PayrollsShow';
import AuditLogsIndex from './pages/audit-logs/AuditLogsIndex';

function AppRoutes() {
  const { isAdmin } = useAuth();

  return (
    <Routes>
      <Route path='/login' element={<LoginPage />} />

      <Route path='/invoices/:id/sign' element={<SignIndex />} />

      <Route path='/' element={<RequireAuth />}>
        <Route index element={<HomePage />} />

        <Route path='/profile' element={<Profile />} />

        {isAdmin && (
          <>
            <Route path='/estimates'>
              <Route index element={<EstimatesIndex />} />
              <Route path='/estimates/new' element={<EstimatesNew />} />
              <Route path='/estimates/:id/edit' element={<EstimatesEdit />} />
            </Route>
            <Route path='/admin/users'>
              <Route index element={<UsersIndex />} />
              <Route path='/admin/users/new' element={<UsersNew />} />
              <Route path='/admin/users/:id/edit' element={<UsersEdit />} />
            </Route>
          </>
        )}

        <Route path='/invoices'>
          <Route index element={<InvoicesIndex />} />
          <Route path='/invoices/:id/edit' element={<InvoicesEdit />} />
          {isAdmin && <Route path='/invoices/new' element={<InvoicesNew />} />}
          <Route path='*' element={<NoMatch />} />
        </Route>

        {isAdmin && (
          <>
            <Route path='/invoice-statuses'>
              <Route index element={<InvoiceStatusesIndex />} />
              <Route
                path='/invoice-statuses/:id/edit'
                element={<InvoiceStatusesEdit />}
              />
              <Route
                path='/invoice-statuses/new'
                element={<InvoiceStatusesNew />}
              />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/transaction-natures'>
              <Route index element={<TransactionNaturesIndex />} />
              <Route
                path='/transaction-natures/:id/edit'
                element={<TransactionNaturesEdit />}
              />
              <Route
                path='/transaction-natures/new'
                element={<TransactionNaturesNew />}
              />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/reminders'>
              <Route index element={<RemindersIndex />} />
              <Route path='/reminders/:id/edit' element={<RemindersEdit />} />
              <Route path='/reminders/new' element={<RemindersNew />} />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/tags'>
              <Route index element={<TagsIndex />} />
              <Route path='/tags/:id/edit' element={<TagsEdit />} />
              <Route path='/tags/new' element={<TagsNew />} />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/services'>
              <Route index element={<ServicesIndex />} />
              <Route path='/services/:id/edit' element={<ServicesEdit />} />
              <Route path='/services/new' element={<ServicesNew />} />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/products'>
              <Route index element={<ProductsIndex />} />
              <Route path='/products/:id/edit' element={<ProductsEdit />} />
              <Route path='/products/new' element={<ProductsNew />} />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/companies'>
              <Route index element={<CompaniesIndex />} />
              <Route path='/companies/:id/edit' element={<CompaniesEdit />} />
              <Route path='/companies/new' element={<CompaniesNew />} />
              <Route path='*' element={<NoMatch />} />
            </Route>

            <Route path='/customers'>
              <Route index element={<CustomersIndex />} />
              <Route path='/customers/:id/edit' element={<CustomersEdit />} />
              <Route path='/customers/new' element={<CustomersNew />} />
              <Route path='*' element={<NoMatch />} />
            </Route>
          </>
        )}

        {isAdmin && (
          <>
            <Route path='/reports'>
              <Route index element={<ReportsIndex />} />
              <Route path='/reports/:report' element={<ReportsShow />} />
            </Route>
            <Route path='/payrolls'>
              <Route index element={<PayrollsIndex />} />
              <Route path='/payrolls/:payrollId' element={<PayrollsShow />} />
            </Route>
            <Route path='/audit-logs'>
              <Route index element={<AuditLogsIndex />} />
              <Route
                path='/audit-logs/:auditLogId'
                element={<PayrollsShow />}
              />
            </Route>
          </>
        )}

        <Route path='*' element={<NoMatch />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
